import { render, staticRenderFns } from "./NoResultsComponent.vue?vue&type=template&id=fa2e106e&scoped=true&lang=pug"
import script from "./NoResultsComponent.vue?vue&type=script&lang=ts"
export * from "./NoResultsComponent.vue?vue&type=script&lang=ts"
import style0 from "./NoResultsComponent.vue?vue&type=style&index=0&id=fa2e106e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2e106e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa2e106e')) {
      api.createRecord('fa2e106e', component.options)
    } else {
      api.reload('fa2e106e', component.options)
    }
    module.hot.accept("./NoResultsComponent.vue?vue&type=template&id=fa2e106e&scoped=true&lang=pug", function () {
      api.rerender('fa2e106e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/search/NoResults/NoResultsComponent.vue"
export default component.exports